import axios from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../api/apiClient";
import {
  fetchDiseaseFailure,
  fetchDiseasesStart,
  fetchDiseaseSuccess,
} from "../../store/features/diseases/diseasesSlice";

const URL = buildApiUrl("/api/v1/disease/disease/");

const selectAccessToken = (state) => state.auth?.user?.access_token;

const getDiseasesApi = async (accessToken) => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchDiseasesSaga() {
  try {
    const accessToken = yield select(selectAccessToken);
    const diseasesData = yield call(getDiseasesApi, accessToken);
    yield put(fetchDiseaseSuccess(diseasesData));
  } catch (error) {
    yield put(fetchDiseaseFailure(error.message));
  }
}

export default function* diseasesSaga() {
  yield takeLatest(fetchDiseasesStart.type, fetchDiseasesSaga);
}
